import React from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

import ErrorDisplay from 'js/components/common/ErrorDisplay';

const Error = styled(ErrorDisplay)`
  margin: 0;
`;

export default inject('page')(observer(({ page }) => <Error>{page.error}</Error>));
